// create store / configure redux store

import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { persistStore } from 'redux-persist';

import reducer from './../reducers';


const configureStore = () => {
  const store = createStore(
    reducer,
    composeWithDevTools(applyMiddleware(thunk)),
  );

  const persistor = persistStore(store);

  return { store, persistor };
};

export default configureStore();
